import React, { useEffect, useMemo, useState } from 'react';
import {
  Button,
  Dialog,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Slide,
  Box,
  Table,
  TableBody,
  TableCell,
  TableRow,
  TableContainer,
  TableHead,
  TextField,
  DialogActions
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import { formatDate } from '../versions/tabs/Constfunctions';
import axiosInstance from 'interceptors/axiosInstance';
import { deleteEstimateAPI, estimateNotesAPI, insertUpdateNoteAPI } from 'api/api';
import Spinnerprogress from 'ui-component/circular-progress/Spinnerprogress';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const NotesFullScreen = ({ fullScreenNotes, setFullScreenNotes, ClientId, ProjectId }) => {
  const columns = ['', 'Note', 'Added BY', 'Added On'];
  const [rows, setRows] = useState([]);
  const [newNote, setNewNote] = useState('');
  const [editingRow, setEditingRow] = useState({isEditing: false, idx: 0});
  const [isLoading, setIsLoading] = useState(false); 
  const [refreshRows, setRefreshRows] = useState(0);

  const handleClose = () => {
    setFullScreenNotes(false);
    setEditingRow({isEditing: false, idx: 0});
    setNewNote('');
  };

  const editNote = (id) => {
    const editNote = rows.find((r) => r.NoteID === id);
    setNewNote(editNote.Notes);
    setEditingRow({isEditing: true, idx: id});
  };

  const deleteNote = async (id) => {
    await axiosInstance
      .delete(deleteEstimateAPI, {params: {
        NoteID: id,
        ClientId: ClientId,
        ProjectId: ProjectId
      }})
      .then(() => {
        setRefreshRows(refreshRows + 1);
      })
      .catch((error) => console.log(error));
  };

  const addNewNote = async (id) => {
    const note = {
        NoteID: id,
        Notes: newNote.trim(),
        ClientID: ClientId,
        ProjectID: ProjectId
      };

    await axiosInstance
      .post(insertUpdateNoteAPI, note)
      .then(() => {
        setRefreshRows(refreshRows + 1);
        setEditingRow({isEditing: false, idx: 0});
      })
      .catch((err) => console.log(err));
    
    setNewNote('');
    }

    const disbleAddBtn = useMemo(() => {
      return newNote.trim() === '';
    },[newNote]);

    useEffect(() => {
      setIsLoading(true);
      const fetchData = async () => {
        await axiosInstance
          .get(`${estimateNotesAPI}?ClientId=${ClientId}&ProjectId=${ProjectId}`)
          .then((res) => {
            setRows(res.data);
          })
          .catch((err) => {
            console.log(err);
          });
      };

      fetchData();
      setIsLoading(false);
    }, [refreshRows,fullScreenNotes ]);

  return (
    <>
      <Dialog fullScreen open={fullScreenNotes} onClose={handleClose} TransitionComponent={Transition} scroll="body">
        <AppBar sx={{ position: 'relative', backgroundColor: '#673ab7' }}>
          <Toolbar>
            <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} color="inherit" variant="h4" component="div">
              Estimate Notes
            </Typography>
          </Toolbar>
        </AppBar>
        <DialogActions sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'flex-end', m: 1 }}>
            <TextField
              id="outlined-basic"
              variant="filled"
              label="Enter here"
              multiline
              fullWidth
              onChange={(e) => setNewNote(e.target.value)}
              value={newNote}
            />
            <div style={{ display: 'flex'}}>
             <Button type="button" variant="contained" color="secondary" sx={{ mt: 2, ml: 2, width: '120px' }} onClick={() => setNewNote('')} >
                Clear
              </Button>
              <Button type="button" variant="contained" color="secondary" sx={{ mt: 2, ml: 2, width: '120px' }} disabled={disbleAddBtn} onClick={() => addNewNote(editingRow.idx)}>
                {editingRow.isEditing ? 'Update Note' : 'Add Note'}
              </Button>
            </div>
          </DialogActions>
        <TableContainer sx={{ m: 2, width: 'auto', maxHeight: '70%' }}>
          <Table stickyHeader aria-label="simple table">
            <TableHead className="detail__tr">
              <TableRow>
                {columns.map((col, idx) => {
                  return (
                    <TableCell key={idx} className={idx == 0 ? 'none' : 'table-cell'}>
                      {col}
                    </TableCell>
                  );
                })}
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row) => {
                return (
                  <TableRow key={row.NoteID + row.Notes}>
                    <TableCell className="table-cell" style={{ width: '7%' }}>
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          color: 'text.secondary'
                        }}
                      >
                        <EditIcon onClick={() => editNote(row.NoteID)} style={{ cursor: 'pointer' }} />
                        <DeleteIcon onClick={() => deleteNote(row.NoteID)} style={{ cursor: 'pointer' }} />
                      </Box>
                    </TableCell>
                    <TableCell>{row.Notes}</TableCell>
                    <TableCell sx={{width: '170px'}}>{row.AddedBy}</TableCell>
                    <TableCell sx={{width: '170px'}}>{formatDate(row.Updated)}</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
        {isLoading && <Spinnerprogress />}
        
      </Dialog>
    </>
  );
};

export default NotesFullScreen;
